const CountDownTimer = ({
  slaMissed = false,
}) => {

  return (
    <>
      {slaMissed && (
        <div className={`slasec slamissed`}>
          <label htmlFor="">SLA Missed</label>
        </div>
      ) }
    </>
  );
};

export default CountDownTimer;
